import React, {Component} from 'react';
import './App.css';
import ArticleList from './components/article-list';
import ArticlePost from './components/article-post';

export default class App extends Component {

  // basic routing behaviour
  hashChanged = () => {
    console.log('Hash changed.');
    this.forceUpdate();
  }

  componentDidMount() {
    console.log('componentDidMount.');
    window.addEventListener("hashchange", this.hashChanged, false);
  }

  render() {

    // Need on onHashChange listener, see 
    // https://www.youtube.com/watch?v=1g1fICJR8YQ



    // only routes, eschew a lib?? But links how?
    let regex = /.html$/i;
    if (window.location.href.match(regex)) {
      return (
        <ArticlePost />
      ); 
    } else {
      return (
        <ArticleList />
      );
    }
  }

}
